import {useEffect, useState} from "react";

/** Tracks whether the clipboard-write permission is granted (updates live). */
export function useClipboardPermission(): boolean {
    const [canUseClipboard, setCanUseClipboard] = useState(false);

    useEffect(() => {
        const queryOpts = {name: "clipboard-write" as PermissionName, allowWithoutGesture: false};
        try {
            navigator.permissions.query(queryOpts)
                .then((status) => {
                    setCanUseClipboard(status.state === "granted");
                    status.onchange = () => {
                        setCanUseClipboard(status.state === "granted");
                    };
                })
                .catch((reason) => console.log("clipboard permission query rejected", reason));
        } catch (e) {
            console.log("error getting clipboard permissions.", e);
        }
    }, []);

    return canUseClipboard;
}
